import ArrowLeft16 from '@carbon/icons-react/es/arrow--left/16';
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import ArrowsHorizontal16 from '@carbon/icons-react/es/arrows--horizontal/16';
import { Space } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HubspotSyncTypes } from 'api/integrations';
import { Option, SingleValueProps } from 'components/atoms/select';
import { HubspotFieldMappingLocalData } from '../../types';
import { syncOptions } from '../use-field-mapping-actions';

const GetSyncIcon = ({ value }: { value: HubspotSyncTypes }) => {
  switch (value) {
    case HubspotSyncTypes.SyncExternalToNative: {
      return <ArrowRight16 style={{ color: 'var(--blue-60)' }} />;
    }

    case HubspotSyncTypes.SyncTwoWay: {
      return <ArrowsHorizontal16 style={{ color: 'var(--blue-60)' }} />;
    }

    case HubspotSyncTypes.SyncNativeToExternal: {
      return <ArrowLeft16 style={{ color: 'var(--blue-60)' }} />;
    }

    default: {
      return null;
    }
  }
};

export const SyncOptionLabel = (data: Option) => {
  const { value, label } = data;

  return (
    <Space align="center">
      <GetSyncIcon value={value as HubspotSyncTypes} />
      <FormattedMessage
        id={`settings.integrations.hubspot.resource_mappings.sync.${label.toLowerCase()}`}
      />
    </Space>
  );
};

export const SelectedSyncValue = ({ data }: SingleValueProps) => (
  <GetSyncIcon value={data.value.toString() as HubspotSyncTypes} />
);

export const SyncSelectStyles = {
  control: (provided) => ({
    ...provided,
    boxShadow: 'none',
    border: 'none',
  }),
  menu: (provided) => ({
    ...provided,
    minWidth: '200px',
    width: 'auto',
  }),
};

export const getValidSyncOptions = (fieldMap: HubspotFieldMappingLocalData) => {
  const isSyncBothWays =
    fieldMap.allowedSyncTypes?.includes(HubspotSyncTypes.SyncTwoWay) ??
    (fieldMap.rocketlaneField?.extra && fieldMap.hubspotField?.extra);
  const isSyncToExternal =
    fieldMap.allowedSyncTypes?.includes(
      HubspotSyncTypes.SyncNativeToExternal,
    ) ?? fieldMap.rocketlaneField?.extra?.isEditable === false;
  const isSyncToNative =
    fieldMap.allowedSyncTypes?.includes(
      HubspotSyncTypes.SyncExternalToNative,
    ) ?? fieldMap.hubspotField?.extra === false;

  switch (true) {
    case isSyncBothWays: {
      return syncOptions;
    }
    case isSyncToExternal: {
      return [
        {
          label: HubspotSyncTypes.SyncNativeToExternal,
          value: HubspotSyncTypes.SyncNativeToExternal,
        },
      ];
    }
    case isSyncToNative: {
      return [
        {
          label: HubspotSyncTypes.SyncExternalToNative,
          value: HubspotSyncTypes.SyncExternalToNative,
        },
      ];
    }
    default: {
      return syncOptions;
    }
  }
};
